/**
 * @flow
 * @relayHash 323f8baea62a5d4719483122d9a06b59
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OrganizationContextProviderFragment_organization$ref = any;
type ProcessingModals_organization$ref = any;
type ProcessingModals_tension$ref = any;
type ProcessingModals_viewer$ref = any;
export type TensionProcessContainerQueryVariables = {|
  orgDatabaseId: string,
  tensionDatabaseId: string,
|};
export type TensionProcessContainerQueryResponse = {|
  +organization: ?{|
    +tension: ?{|
      +$fragmentRefs: ProcessingModals_tension$ref
    |},
    +viewer: {|
      +$fragmentRefs: ProcessingModals_viewer$ref
    |},
    +$fragmentRefs: ProcessingModals_organization$ref & OrganizationContextProviderFragment_organization$ref,
  |}
|};
export type TensionProcessContainerQuery = {|
  variables: TensionProcessContainerQueryVariables,
  response: TensionProcessContainerQueryResponse,
|};
*/


/*
query TensionProcessContainerQuery(
  $orgDatabaseId: String!
  $tensionDatabaseId: String!
) {
  organization(databaseId: $orgDatabaseId) {
    ...ProcessingModals_organization
    ...OrganizationContextProviderFragment_organization
    tension(databaseId: $tensionDatabaseId) {
      ...ProcessingModals_tension
      id
    }
    viewer {
      ...ProcessingModals_viewer
      id
    }
    id
  }
}

fragment AgendaProcessModal_tension on Tension {
  databaseId
  organization {
    databaseId
    id
  }
}

fragment OrganizationContextProviderFragment_organization on Organization {
  id
  databaseId
  name
  isWysiwygEnabled
  onRestrictedPlan
  isOnV5
  isOnV4
  isROIEnabled
  isAiEnabled
  showChecklists: featureEnabled(name: "checklists")
  showGoals: featureEnabled(name: "goals")
  showHistory: featureEnabled(name: "history")
  showMetrics: featureEnabled(name: "metrics")
  showNotes: featureEnabled(name: "notes")
  showPolicies: featureEnabled(name: "policies")
  showProjects: featureEnabled(name: "projects")
  checklistsLabel: termFor(name: "checklists")
  goalsLabel: termFor(name: "goals")
  historyLabel: termFor(name: "history")
  metricsLabel: termFor(name: "metrics")
  notesLabel: termFor(name: "notes")
  policiesLabel: termFor(name: "policies")
  projectsLabel: termFor(name: "projects")
}

fragment ProcessingModals_organization on Organization {
  databaseId
}

fragment ProcessingModals_tension on Tension {
  databaseId
  proposal {
    databaseId
    id
  }
  ...TensionProcessModal_tension
  ...AgendaProcessModal_tension
}

fragment ProcessingModals_viewer on Person {
  databaseId
}

fragment TensionGuide_tension on Tension {
  id
  databaseId
  impactedRole {
    governanceEnabled
    id
  }
}

fragment TensionGuide_viewer on Person {
  id
  databaseId
  hasCirclesWithGovernanceOn
  routes {
    addActionPath
    addProjectPath
  }
}

fragment TensionInfo_organization on Organization {
  ...WYSIWYGViewerWithFeatureFlag_organization
}

fragment TensionInfo_tension on Tension {
  createdAt
  body
  agendaLabel
  impactedRole {
    localizedName
    id
  }
  person {
    id
    name
    isActive
  }
  organization {
    ...TensionInfo_organization
    id
  }
}

fragment TensionProcessModal_tension on Tension {
  ...TensionGuide_tension
  ...TensionInfo_tension
  organization {
    viewer {
      ...TensionGuide_viewer
      id
    }
    id
  }
}

fragment WYSIWYGViewerWithFeatureFlag_organization on Organization {
  isWysiwygEnabled
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgDatabaseId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tensionDatabaseId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "tensionDatabaseId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWysiwygEnabled",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "checklists"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "goals"
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "history"
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "metrics"
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "notes"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "policies"
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "projects"
  }
],
v14 = [
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TensionProcessContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Tension",
            "kind": "LinkedField",
            "name": "tension",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProcessingModals_tension"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProcessingModals_viewer"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProcessingModals_organization"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrganizationContextProviderFragment_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TensionProcessContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onRestrictedPlan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOnV5",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOnV4",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isROIEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAiEnabled",
            "storageKey": null
          },
          {
            "alias": "showChecklists",
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"checklists\")"
          },
          {
            "alias": "showGoals",
            "args": (v8/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"goals\")"
          },
          {
            "alias": "showHistory",
            "args": (v9/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"history\")"
          },
          {
            "alias": "showMetrics",
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"metrics\")"
          },
          {
            "alias": "showNotes",
            "args": (v11/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"notes\")"
          },
          {
            "alias": "showPolicies",
            "args": (v12/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"policies\")"
          },
          {
            "alias": "showProjects",
            "args": (v13/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"projects\")"
          },
          {
            "alias": "checklistsLabel",
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"checklists\")"
          },
          {
            "alias": "goalsLabel",
            "args": (v8/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"goals\")"
          },
          {
            "alias": "historyLabel",
            "args": (v9/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"history\")"
          },
          {
            "alias": "metricsLabel",
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"metrics\")"
          },
          {
            "alias": "notesLabel",
            "args": (v11/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"notes\")"
          },
          {
            "alias": "policiesLabel",
            "args": (v12/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"policies\")"
          },
          {
            "alias": "projectsLabel",
            "args": (v13/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"projects\")"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Tension",
            "kind": "LinkedField",
            "name": "tension",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Proposal",
                "kind": "LinkedField",
                "name": "proposal",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "impactedRole",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "governanceEnabled",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "localizedName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "agendaLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasCirclesWithGovernanceOn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routes",
                        "kind": "LinkedField",
                        "name": "routes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "addActionPath",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "addProjectPath",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "323f8baea62a5d4719483122d9a06b59",
    "metadata": {},
    "name": "TensionProcessContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1e0d6aabd7ad7ccd53011980553a7134';

module.exports = node;
